import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';
import { HeadingProps, Li as SUILi, Heading as SUIHeading, Text } from '@slal/ui/typography';
import { TextExtendedProps } from './Text';

export const Li = styled(SUILi)`
    line-height: 24px;
`;

const getHeadingSizes = (isDesktop: boolean | null, { level }: HeadingProps) => {
    let fontSize: string;
    let lineHeight: string;
    switch (level) {
        case 1:
            fontSize = isDesktop ? '36px' : '28px';
            lineHeight = isDesktop ? '44px' : '36px';
            break;
        case 2:
            fontSize = isDesktop ? '32px' : '28px';
            lineHeight = isDesktop ? '40px' : '36px';
            break;
        case 3:
            fontSize = '24px';
            lineHeight = '32px';
            break;
        case 4:
            fontSize = '18px';
            lineHeight = '24px';
            break;
        case 5:
            fontSize = '16px';
            lineHeight = '24px';
            break;
        default:
            fontSize = '16px';
            lineHeight = '24px';
            break;
    }

    return `font-size: ${fontSize};
            line-height: ${lineHeight};`;
};

export const Heading = styled(SUIHeading)`
    ${props => getHeadingSizes(null, props)};

    ${props =>
        breakpointUp.md`
        ${getHeadingSizes(true, props)};
    `}
`;

export const StyledTextLikeHeading = styled(Heading)`
    font-family: ${({ theme }) => theme.fonts.sansSerif.family};
    font-size: ${({ theme }) => theme.fontSizes[4]};
    font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
`;

const getTextSizes = ({ size }: TextExtendedProps) => {
    let fontSize: string;
    switch (size) {
        case 'lg':
            fontSize = '18px';
            break;
        case 'sm':
            fontSize = '14px';
            break;
        default:
            fontSize = '16px';
    }

    return `font-size: ${fontSize};
            line-height: 24px;`;
};

export const StyledText = styled(Text)<TextExtendedProps>`
    ${props => getTextSizes(props)}
`;
